module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body w-100"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "none",
      "background": "rgba(255, 255, 255, 0.7)",
      "z-index": "1000"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "top": "50%",
      "left": "50%",
      "position": "absolute",
      "font-size": "30px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column all-centered table-container"
  }, [(!_vm.visualizarLicenca && !_vm.validarLicenca && !_vm.editarLicenca) ? _c('b-container', {
    staticClass: "w-100",
    attrs: {
      "fluid": ""
    }
  }, [_c('legend', {
    staticStyle: {
      "background-color": "#fcfcfc"
    }
  }, [_c('i', {
    staticClass: "fa fa-paste",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Validação de Licenças\n             ")]), _vm._v(" "), (_vm.todasLicencas) ? _c('div', {
    staticClass: "row-flex all-start gap-10 w-100"
  }, [_c('div', {
    staticClass: "filtro-container w-80"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Selecione um projeto: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroProjetoSelecionado),
      expression: "filtroProjetoSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Projeto",
      "placeholder": "Selecione",
      "aria-hidden": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroProjetoSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.aplicarFiltros()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Projeto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TODOS"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.filtroProjetos), function(projeto) {
    return _c('option', {
      domProps: {
        "value": projeto
      }
    }, [_vm._v(_vm._s(projeto))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "filtro-container w-20"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Status: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroStatusSelecionado),
      expression: "filtroStatusSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Projeto",
      "placeholder": "Selecione",
      "aria-hidden": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroStatusSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.aplicarFiltros()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TODOS"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.filtroStatus), function(status) {
    return _c('option', {
      domProps: {
        "value": status
      }
    }, [_vm._v(_vm._s(status))])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('div', {
          staticClass: "row-flex all-centered",
          staticStyle: {
            "gap": "5px"
          }
        }, [(_vm.verificarStatusValidacao(row.item)) ? _c('b-button', {
          staticClass: "btn btn-success btn-sm btn-flat",
          attrs: {
            "type": "button",
            "data-cy": "edita-licenca-procedimento"
          },
          on: {
            "click": function($event) {
              return _vm.abrirAnexoLicenca(row.item, row.index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check-circle",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Validar")]) : _vm._e(), _vm._v(" "), (_vm.verificarStatusEdicao(row.item)) ? _c('b-button', {
          staticClass: "btn btn-warning btn-sm btn-flat",
          attrs: {
            "type": "button",
            "data-cy": "exclui-licenca-procedimento"
          },
          on: {
            "click": function($event) {
              return _vm.editaLicenca(row.item, row.index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("  Editar")]) : _vm._e(), _vm._v(" "), _c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "data-cy": "exclui-licenca-procedimento"
          },
          on: {
            "click": function($event) {
              return _vm.visualizaLicenca(row.item, row.index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-eye",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("  Visualizar")]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.todasLicencas) ? _c('b-button', {
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "data-cy": "exclui-licenca-procedimento"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.confirmaExclusao('Atenção, este procedimento não poderá ser desfeito. Confirma Exclusão?', function () { return _vm.preparaExclusao(row.item); })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")]) : _vm._e()], 1)]
      }
    }, {
      key: "prazo_apresentacao",
      fn: function(row) {
        return [(row.value == '') ? _c('span', [_vm._v("\n                   -\n                 ")]) : _c('span', [(_vm.moment.utc(row.value).endOf('day').isBefore(_vm.moment.utc())) ? _c('span', {
          staticClass: "badge badge-danger",
          attrs: {
            "title": "Vencida"
          }
        }, [_vm._v("\n                     Prazo vencido em " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n                   ")]) : (row.value) ? _c('span', {
          staticClass: "badge badge-success",
          attrs: {
            "title": "Dentro da validade"
          }
        }, [_vm._v("\n                     " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n                   ")]) : _vm._e()])]
      }
    }, {
      key: "data_apresentacao",
      fn: function(row) {
        return [(row.value == '') ? _c('div', [_c('b', [_vm._v("Não Apresentado")])]) : _c('div', [_vm._v("\n                   " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n                 ")])]
      }
    }, {
      key: "validade",
      fn: function(row) {
        return [(row.value && _vm.moment.utc(row.value).endOf('day').isBefore(_vm.moment.utc())) ? _c('span', {
          staticClass: "badge badge-danger",
          attrs: {
            "title": "Vencida"
          }
        }, [_c('i', {
          staticClass: "fa fa-warning",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Vencida em " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n                   ")]) : (row.value) ? _c('span', {
          staticClass: "badge badge-success",
          attrs: {
            "title": "Dentro da validade"
          }
        }, [_vm._v("\n                     " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n                   ")]) : _c('span', [_vm._v("\n                     -\n                   ")])]
      }
    }, {
      key: "status",
      fn: function(row) {
        return [_c('span', {
          class: _vm.statusClass(row.value)
        }, [_vm._v("\n                   " + _vm._s(row.value) + "\n                 ")])]
      }
    }, {
      key: "tipo_licenca",
      fn: function(row) {
        return [_vm._v("\n                   " + _vm._s(row.value.replace('_', ' ')) + "\n               ")]
      }
    }], null, false, 2785024838)
  }), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-end w-100 gap-10"
  }, [_c('div', [_vm._v("\n                 (" + _vm._s(_vm.table.items.length) + ") Licenças Encontradas\n               ")]), _vm._v(" "), (_vm.todasLicencas) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.limparFiltros()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.table.items.length,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.validarLicenca || _vm.visualizarLicenca || _vm.editarLicenca) ? _c('div', {
    staticClass: "envio-container column start-centered"
  }, [_c('legend', [_vm._v("\n           Validação de Licença\n       ")]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start gap-10 w-100"
  }, [_c('div', {
    staticClass: "w-80"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome do projeto:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "0000 Nome do Projeto",
      "disabled": ""
    },
    domProps: {
      "value": _vm.licencaTemplate.projeto
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-20"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaTemplate.status),
      expression: "licencaTemplate.status"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Status",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.licencaTemplate.status)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.licencaTemplate, "status", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-20"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Fase:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaTemplate.fase_proposta),
      expression: "licencaTemplate.fase_proposta"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Fase",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.licencaTemplate.fase_proposta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.licencaTemplate, "fase_proposta", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start gap-10 w-100"
  }, [_c('div', {
    staticClass: "w-70"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Tipo de Licença:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaTemplate.licenca),
      expression: "licencaTemplate.licenca"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Tipo de Licença",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.licencaTemplate.licenca)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.licencaTemplate, "licenca", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-10"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de Validade:")]), _vm._v(" "), _c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataInicial",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy",
      "disabled": ""
    },
    model: {
      value: (_vm.licencaTemplate.validade),
      callback: function($$v) {
        _vm.$set(_vm.licencaTemplate, "validade", $$v)
      },
      expression: "licencaTemplate.validade"
    }
  })], 1), _vm._v(" "), (!_vm.editarLicenca) ? _c('div', {
    staticClass: "w-20"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Prazo de Apresentação:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaTemplate.prazo_apresentacao),
      expression: "licencaTemplate.prazo_apresentacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Prazo de Apresentação",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.licencaTemplate.prazo_apresentacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.licencaTemplate, "prazo_apresentacao", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.editarLicenca) ? _c('div', {
    staticClass: "w-20"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Prazo de Apresentação:")]), _vm._v(" "), _c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataInicial",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.licencaTemplate.prazo_apresentacao),
      callback: function($$v) {
        _vm.$set(_vm.licencaTemplate, "prazo_apresentacao", $$v)
      },
      expression: "licencaTemplate.prazo_apresentacao"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-20"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Apresentado em:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaTemplate.data_apresentacao),
      expression: "licencaTemplate.data_apresentacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Prazo de Apresentação",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.licencaTemplate.data_apresentacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.licencaTemplate, "data_apresentacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Observação:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaTemplate.observacoes),
      expression: "licencaTemplate.observacoes"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Observações Adicionais",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.licencaTemplate.observacoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.licencaTemplate, "observacoes", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Anexo:")]), _vm._v(" "), _c('uploadLicencas', {
    staticClass: "w-100",
    attrs: {
      "propDocumentos": _vm.licencaTemplate.anexo,
      "localUso": "LICENCIAMENTO_AMBIENTAL",
      "maxFiles": 1,
      "disable": true
    }
  })], 1), _vm._v(" "), _c('b-container', {
    staticClass: "w-100",
    attrs: {
      "fluid": ""
    }
  }, [_c('legend', [_vm._v("\n           Histórico\n         ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.showTable),
      expression: "loading.showTable"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "none",
      "background": "rgba(255, 255, 255, 0.7)",
      "z-index": "1000"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "top": "50%",
      "left": "50%",
      "position": "absolute",
      "font-size": "30px"
    }
  })]), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.tableHistorico.bordered,
      "items": _vm.tableHistorico.items,
      "hover": _vm.tableHistorico.hover,
      "fields": _vm.tableHistorico.fields,
      "filter": _vm.tableHistorico.filter,
      "current-page": _vm.tableHistorico.currentPage,
      "per-page": _vm.tableHistorico.perPage,
      "sort-by": _vm.tableHistorico.sortBy,
      "sort-desc": _vm.tableHistorico.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tableHistorico, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tableHistorico, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tableHistorico, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tableHistorico, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "created_at",
      fn: function(row) {
        return [_vm._v("\n           " + _vm._s(_vm.moment(row.value).format('DD/MM/YYYY HH:mm:ss')) + "\n         ")]
      }
    }], null, false, 1735301358)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-100 column centered-start gap-10"
  }, [(_vm.validarLicenca) ? _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Decisão:")]), _vm._v(" "), _c('span', [_c('label', {
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "7px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaTemplate.decisao),
      expression: "licencaTemplate.decisao"
    }],
    attrs: {
      "type": "radio",
      "value": "Validado"
    },
    domProps: {
      "checked": _vm._q(_vm.licencaTemplate.decisao, "Validado")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.licencaTemplate, "decisao", "Validado")
      }
    }
  }), _vm._v(" Validar\n                 "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "7px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaTemplate.decisao),
      expression: "licencaTemplate.decisao"
    }],
    attrs: {
      "type": "radio",
      "value": "Devolvido para Ajustes"
    },
    domProps: {
      "checked": _vm._q(_vm.licencaTemplate.decisao, "Devolvido para Ajustes")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.licencaTemplate, "decisao", "Devolvido para Ajustes")
      }
    }
  }), _vm._v(" Devolver para Ajustes\n                 "), _c('div', {
    staticClass: "new-control-indicator"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.validarLicenca || _vm.editarLicenca) ? _c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaTemplate.justificativaDecisao),
      expression: "licencaTemplate.justificativaDecisao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Justificativa da decisão aqui"
    },
    domProps: {
      "value": (_vm.licencaTemplate.justificativaDecisao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.licencaTemplate, "justificativaDecisao", $event.target.value)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.validarLicenca) ? _c('div', {
    staticClass: "row-flex centered-end w-100 gap-5"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleValidacao(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.validaLicenca()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Atualizar Status Licença ")])], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicenca) ? _c('div', {
    staticClass: "row-flex centered-end w-100 gap-5"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEdicao(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.atualizaPrazoLicenca()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Atualizar Prazo de Apresentação ")])], 1) : _vm._e(), _vm._v(" "), (_vm.visualizarLicenca) ? _c('div', {
    staticClass: "row-flex centered-end w-100 gap-5"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleVisualizacao(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Voltar ")])], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-985f90ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/licenciamentoAmbiental/validacaoLicencas.vue
// module id = 2047
// module chunks = 1